import { createFileRoute } from '@tanstack/react-router';
import { ITEM_TYPE_ORDER, SYSTEM_ITEM_VIEWS, type ItemType, type ItemViewKey } from '@aslen/core';
import { ItemsPage, type ItemsSearch } from '@/features/items/items-page';

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined);

export const Route = createFileRoute('/_app/items/')({
  // every filter of W-04 lives in the URL: back from a product card restores the
  // list exactly, and a filtered list can be pasted to the other partner
  validateSearch: (s: Record<string, unknown>): ItemsSearch => ({
    view: (SYSTEM_ITEM_VIEWS as readonly string[]).includes(s.view as string) ? (s.view as ItemViewKey) : undefined,
    type: (ITEM_TYPE_ORDER as string[]).includes(s.type as string) ? (s.type as ItemType) : undefined,
    q: str(s.q),
    size: str(s.size),
    fold: str(s.fold),
    colour: str(s.colour),
    print: str(s.print),
    gsm: str(s.gsm),
  }),
  component: function Items() {
    return <ItemsPage search={Route.useSearch()} />;
  },
});
